import { requestNotificationPermission } from "../../service/firebaseNotification";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import logo from "../../assets/logo.png";
import "./login.css";
import loginRequest from "../../service/Authservice";
import { Alert, Snackbar } from "@mui/material";
import { useAuth } from "../../context/AuthContext";

function Signin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setloading] = useState(false);

  // useEffect(() => {
  //   data();
  // }, []);

  // const data = async () => {
  //   try {
  //     const plaintext = "admin@gmail.com";
  //     const enemail = encryptString(plaintext);

  //     // ----------------------------------------------------
  //     const params = {
  //       email: enemail,
  //     };
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_BASE_URL}DemoHmac`,
  //       params,
  //       {
  //         headers: {
  //           "Access-key": generateKey(),
  //         },
  //       }
  //     );
  //     const encrypted_string = response.data.data;

  //     const deemail = decryptString(encrypted_string);
  //     console.log(deemail);
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleLogin = async (values) => {
    setloading(true);
    try {
      const data = await loginRequest(values);
      console.log(data);
      const admin = data?.data?.data || {};

      const requiresTwoFactor = admin.requires2FA;

      console.log(requiresTwoFactor);
      if (requiresTwoFactor) {
        const temporaryToken = admin.tempToken;

        if (!temporaryToken) {
          throw new Error("Two-factor verification token was not returned.");
        }

        sessionStorage.setItem(
          "pendingAdmin2FA",
          JSON.stringify({
            tempToken: temporaryToken,
            email: values.email,
            admin,
          }),
        );
        setloading(false);
        console.log(admin);
        if (admin.qrCodeUrl) {
          navigate("/TwoFactorSetup", { replace: true });
        } else {
          navigate("/TwoFactorVerify", { replace: true });
        }
        return;
      }

      sessionStorage.removeItem("pendingAdmin2FA");
      login(admin);

      const token = await requestNotificationPermission();
      console.log("FCM TOKEN:", token);
      // if (token) {
      //   await saveFCMToken({
      //     fcmToken: token,
      //   });
      // }
      setloading(false);
      navigate("/Dashboard", { replace: true });
    } catch (error) {
      setError(error.message);
      setOpen(true);
      setloading(false);
    }
  };

  const validate = (values) => {
    const errors = {};

    if (!values.email) {
      errors.email = "Required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }
    if (!values.password) {
      errors.password = "Required";
    } else if (values.password.length < 4) {
      errors.password = "Must be at least 4 characters";
    } else if (values.password.length > 20) {
      errors.password = "Must be 20 characters or less";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate,
    onSubmit: (values) => {
      handleLogin(values);
      // navigate('/Dashboard');
    },
  });

  return (
    <div className="App">
      <div className="Auth-logo">
        <img src={logo} className="logo_img" alt="Wally Market" />
      </div>

      <div className="Auth-form-container1">
        <div className="Auth-form1">
          <div className="Auth-form-content1">
            <h3 className="Auth-form-title">Log In</h3>
            <form onSubmit={formik.handleSubmit} className="Auth_formdata">
              <div className="form-group mt-3">
                <label className="Auth_label">Email address</label>
                <input
                  type="email"
                  className="Auth_input"
                  placeholder="Enter email"
                  name="email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                {formik.errors.email ? (
                  <p className="invalid">{formik.errors.email} </p>
                ) : null}

                {/* <Form.Control.Feedback  className="invalid">
                  {emailError}
                </Form.Control.Feedback> */}
              </div>
              <br />
              <div className="form-group mt-3">
                <label className="Auth_label">Password</label>
                <input
                  type="password"
                  name="password"
                  className="Auth_input"
                  placeholder="Enter password"
                  onChange={formik.handleChange}
                  value={formik.values.password}
                />
                {formik.errors.password ? (
                  <p className="invalid">{formik.errors.password} </p>
                ) : null}

                {/* <Form.Control.Feedback  className="invalid">
                  {PasswordError}
                </Form.Control.Feedback> */}
              </div>

              <br />
              {/* <p
                className="forgot-password text-right mt-2"
                onClick={() => navigate("/ForgetPassword")}
              >
                Forgot password?
              </p> */}

              <div style={{ display: "flex", justifyContent: "left" }}></div>
              <button
                type="submit"
                className="Auth_button"
                disabled={loading}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                {loading ? "Loading...." : "Login"}
              </button>
            </form>
          </div>
        </div>
      </div>

      <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
        <Alert variant="filled" severity="error">
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Signin;
